import { useState } from 'react';
import { FileText, Search, ExternalLink } from 'lucide-react';

export default function ReportsTab({ reports }) {
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');

  const filtered = reports.filter(r => {
    if (filter === 'unlocked' && !r.unlocked) return false;
    if (filter === 'locked' && r.unlocked) return false;
    if (search) {
      const q = search.toLowerCase();
      return (r.report_id?.includes(q) || r.country?.toLowerCase().includes(q) || r.home_profile?.home_type?.toLowerCase().includes(q));
    }
    return true;
  });

  return (
    <div className="space-y-4" data-testid="reports-tab">
      <div className="flex flex-wrap gap-3 items-center">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <input
            type="text"
            placeholder="Search by ID, country, home type..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            className="w-full pl-9 pr-3 py-2 text-sm border border-border rounded-lg bg-white"
            data-testid="reports-search"
          />
        </div>
        <div className="flex gap-1">
          {['all', 'unlocked', 'locked'].map(f => (
            <button key={f} onClick={() => setFilter(f)}
              className={`px-3 py-1.5 text-xs rounded-md capitalize ${filter === f ? 'bg-primary text-white' : 'bg-muted text-muted-foreground hover:bg-muted/80'}`}
              data-testid={`filter-${f}`}>
              {f}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-xl border border-border shadow-sm overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted/50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Report</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Country</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Home Type</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Status</th>
              <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground">Date</th>
              <th className="px-4 py-3"></th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {filtered.length === 0 ? (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-muted-foreground">No reports found</td></tr>
            ) : filtered.map(r => (
              <tr key={r.report_id} className="hover:bg-muted/30">
                <td className="px-4 py-3 font-mono text-xs">{r.report_id?.slice(0, 8)}...</td>
                <td className="px-4 py-3">{r.country}</td>
                <td className="px-4 py-3">{r.home_profile?.home_type}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs px-2 py-0.5 rounded-full ${r.unlocked ? 'bg-green-100 text-green-700' : 'bg-muted text-muted-foreground'}`}>
                    {r.unlocked ? 'Unlocked' : 'Locked'}
                  </span>
                  {r.plan && <span className="ml-1 text-xs text-primary">{r.plan}</span>}
                </td>
                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(r.created_at).toLocaleDateString()}</td>
                <td className="px-4 py-3">
                  <a href={`/report/${r.report_id}`} target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                    <ExternalLink className="w-3.5 h-3.5" />
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="text-xs text-muted-foreground">{filtered.length} of {reports.length} reports</p>
    </div>
  );
}
